// src/services/auth.js
import {
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    signOut
} from "firebase/auth";
import { auth } from "../firebase";
import { getRuntimeConfig } from "../runtimeConfig";

const API_URL = getRuntimeConfig("API_BASE_URL", "");

export const loginWithEmail = async (email, password) => {
    try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        return userCredential.user;
    } catch (err) {
        console.error("Login error:", err);
        throw err;
    }
};

export const signupWithEmail = async (email, password) => {
    try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        const token = await user.getIdToken();

        const response = await fetch(`${API_URL}/api/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                uid: user.uid,
                email: email
            })
        });

        if (!response.ok) {
            await user.delete();
            const errorData = await response.json();
            throw new Error(errorData.error || 'Registration failed');
        }

        return user;
    } catch (err) {
        console.error("Signup error:", err);
        throw err;
    }
};

export const logoutUser = async () => {
    try {
        await signOut(auth);
    } catch (err) {
        console.error("Logout error:", err);
        throw err;
    }
};
